module.exports = __webpack_public_path__ + "static/media/izmeritelnye_preobrazovateli_vlkz.04b3b0f0.pdf";